"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _context = _interopRequireDefault(require("../../utils/context"));
var _MissingElement = _interopRequireDefault(require("./MissingElement"));
var _jsxRuntime = require("react/jsx-runtime");
const DEBUG = process.env.NODE_ENV === 'development';
const DocumentRegistry = ({
  children
}) => {
  const typo3Context = (0, _react.useContext)(_context.default);
  if (!typo3Context) {
    throw new Error('Typo3Context must be provided for DocumentRegistry');
  }
  const {
    document,
    documentsRegister
  } = typo3Context;
  const Component = documentsRegister[document.type];
  if (!Component) {
    if (DEBUG) {
      return (0, _jsxRuntime.jsxs)(_MissingElement.default, {
        children: ["Missing document: ", (0, _jsxRuntime.jsx)("strong", {
          children: document.type
        }), " in DocumentsRegister"]
      });
    }
    return null;
  }
  return (0, _jsxRuntime.jsx)(Component, {
    children: children
  });
};
var _default = DocumentRegistry;
exports.default = _default;